import { Container, Col, Row } from "reactstrap";
import * as PageQL from "queries/page";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import PageSchema from "@common/schema/page/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.pages"}
        query={PageQL.list}
        variables={params}
        schema={PageSchema}
        widgets={widgets}
        target={{ $ref: "/Public/Page" }}
        empty={"No pages yet."}
        config={{
          // Deliberately not `body`: it is the one unbounded field on the row
          // and a listing is not where you read it.
          "/Public/Page": {
            fields: ["title", "slug", "createdAt"],
          },
        }}
        content={({ item: { pageId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${pageId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
